import { defaultParamsSerializer } from '@repository/RequestClient';

export default class UtmRq {
  // 매체 / 앱 / 서비스 / 사이트 명을 의미
  utm_source?: string;
  //매체 내 구좌를 의미
  //매체가 정의하는 구좌의 이름 / 속성을 그대로 사용
  utm_medium?: string;
  //이벤트 명 or 프로젝트 명 을 의미.
  utm_campaign?: string;
  //소재명을 의미. 주제나 내용을 표기
  utm_content?: string;

  constructor(query: Record<string, any>) {
    this.utm_source = query.utm_source;
    this.utm_medium = query.utm_medium;
    this.utm_campaign = query.utm_campaign;
    this.utm_content = query.utm_content;
  }

  getQueryString() {
    return defaultParamsSerializer(this) || undefined;
  }
}
